import { gql, useQuery } from '@apollo/client'

import {
  ItemDetailBoxFragmentDoc,
  ResaleApplicationCreatePrecautionQuery,
  ResaleApplicationCreatePrecautionQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { removeResaleApplicationInput } from '@/core/native/storage'
import { decodeSkuId } from '@/core/sku'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { router, generatePath, routerPages } =
    useRouter<{ itemId: string; skuId?: string }>()
  const itemId = router.query.itemId
  const skuId = router.query?.skuId

  const { data } = useQuery<
    ResaleApplicationCreatePrecautionQuery,
    ResaleApplicationCreatePrecautionQueryVariables
  >(QUERY, {
    variables: {
      id: itemId,
      skuId: decodeSkuId(skuId ?? '') || undefined,
    },
  })

  return {
    state: {
      // 購入手数料
      purchaseFee: data?.item?.metadata?.ticket?.resaleFee?.purchaseFee || 0,
    },
    actions: {
      onSubmit: async () => {
        await removeResaleApplicationInput()
        router.push({
          pathname: generatePath(routerPages.ResaleApplicationCreate, {
            itemId,
          }),
          search: `${skuId ? `?skuId=${skuId}` : ''}`,
        })
      },
    },
  }
})

const QUERY = gql`
  query ResaleApplicationCreatePrecaution($id: ID!, $skuId: String) {
    item(id: $id) {
      ...ItemDetailBox
    }
  }
  ${ItemDetailBoxFragmentDoc}
`
